export default __webpack_public_path__ + "static/media/15_Vecow.2d2f9ce5.png";